// extracted by mini-css-extract-plugin
export var bounce = "_oh-1";
export var generatingText = "_oh-6";
export var lightning = "_oh-4";
export var popup = "_oh-5";
export var progressBar = "_oh-7";
export var progressFill = "_oh-8";
export var progressShimmer = "_oh-9";
export var progressText = "_oh-a";
export var shimmer = "_oh-3";
export var uploadIcon = "_oh-0";
export var uploadingText = "_oh-2";